import * as angular from "angular";
import { AppTypeDataProvider } from "../../../data-provider/app-type.dp";
import { EffortDataProvider } from "../../../data-provider/effort.dp";
import { NavigationBarHelperService } from "../../navigation/navigation-bar.helper";
import { Effort } from "../../../models/effort.model";
import { Group } from "../../../models/group.model";
import { Team } from "../../../models/team.model";
import { DialogUtils } from "../../../helper/dialog.helper";
import { ScreenUtils } from "../../../helper/screen.helper";
import { ToastUtils } from "../../../helper/toast.helper";
import { TeamDataProvider } from "../../../data-provider/team.dp";
import { Utils } from "../../../helper/utils.helper";
import { PermissionCheck } from "../../../shared/permission";

let TeamScoreBoardComponent = {
    selector: "vcTeamScoreBoard",
    templateUrl:
        "/angular/components/team/score-board/team-score-board.component.html",
    bindings: {},
    controller: class TeamScoreBoardController {
        public teamId: string | number;
        public teamData = [];
        public loadingStatus = {
            stats: false,
            content: true,
            details: false,
        };
        public filter: any;
        public acordion_status = false;
        public team: Team;
        public efforts: Effort[];

        private readonly $scope: any;
        private readonly toast: ToastUtils;
        private readonly dialog: DialogUtils;
        private readonly modelsUtils: any;
        private $route: any;
        private $location: any;
        private $window: any;
        private navigationBarService: NavigationBarHelperService;
        public readonly __env: any;
        public utils: Utils;
        public screen: ScreenUtils;
        public permissionProvider: PermissionCheck;

        private effortDataProvider: EffortDataProvider;
        private dataProvider: TeamDataProvider;
        private appTypeDataProvider: AppTypeDataProvider;

        constructor(
            $scope: any,
            $route: any,
            $routeParams: any,
            $location: any,
            $window: any,
            __env: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            Utils: Utils,
            ScreenUtils: ScreenUtils,
            EffortDataProvider: EffortDataProvider,
            PermissionCheck: PermissionCheck,
            TeamDataProvider: TeamDataProvider,
            AppTypeDataProvider: AppTypeDataProvider,
            NavigationBarHelperService: NavigationBarHelperService
        ) {
            this.$scope = $scope;
            this.$route = $route;
            this.$location = $location;
            this.$window = $window;
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.utils = Utils;
            this.screen = ScreenUtils;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;

            this.effortDataProvider = EffortDataProvider;
            this.dataProvider = TeamDataProvider;
            this.appTypeDataProvider = AppTypeDataProvider;

            this.teamId = $routeParams.tid;
            this.team = this.modelsUtils.team();
            this.dataProvider
                .getTeam(this.teamId, this.filter)
                .then((team: Team) => {
                    this.team.setData(team);
                    if (this.team.users.length) {
                        this.team.users.forEach((user: any, index: number) => {
                            this.team.users[index] =
                                this.modelsUtils.user(user);
                        });
                    }
                });
            this.navigationBarService.setShowBackButton(true);

            this.filter = {
                app_type: "all",
                effort: null,
                date_range: "all",
                direction: "desc",
                order: "canvasses",
            };

            this.dataProvider.clearAll();
            this.dataProvider.getDetails(this.teamId).then((json: any) => {
                this.loadingStatus.details = true;
                this.teamData = json.data;
            });

            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;
                });
        }

        $onInit() {}

        goToGroup(group: Group): void {
            const strippedBackGroup = { gid: group.gid, gname: group.gname };
            this.$window.location =
                "/#/people?group=" +
                encodeURIComponent(JSON.stringify(strippedBackGroup));
        }

        openEditTeamDialog(team: Team, ev: any): void {
            this.dialog
                .show({
                    component: "vc-team-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large-plus",
                    ariaLabel: "Create Team",
                    locals: {
                        selectedTeam: team,
                        hideUsers: false,
                    },
                })
                .then((newTeam: Team) => {
                    if (team && newTeam) {
                        this.$route.reload(); //need to get the stats for the new members
                    }
                });
        }

        deleteTeam(team: Team, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: "Delete Team?",
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.dataProvider.deleteTeam(team).then(
                        () => {
                            this.toast.success("Team deleted");
                            this.$location.url("/teams?filter=%7B%7D");
                            this.dialog.cancel();
                        },
                        () => this.toast.error()
                    );
                });
        }

        checkLoading(loading: string, status: string): void {
            if (loading == "content") {
                this.loadingStatus.content = status == "start" ? true : false;
            } else {
                this.loadingStatus.stats = status == "start" ? true : false;
            }
        }
    },
};

angular
    .module("team")
    .component(TeamScoreBoardComponent.selector, TeamScoreBoardComponent);
